import { dia, shapes } from '@joint/core';

export const Child = shapes.standard.Rectangle.define('app.Child', {
    z: 1,
    attrs: {
        root: {
            cursor: 'default'
        },
        body: {
            fill: 'rgba(70,101,229,0.15)',
            stroke: '#4665E5',
            strokeWidth: 1,
            rx: 2,
            ry: 2,
        },
        label: {
            class: 'inner-label',
            fontFamily: 'sans-serif',
            textWrap: {
                width: -10
            }
        }
    },
    ports: {
        groups: {
            port: {
                position: {
                    name: 'absolute'
                },
                attrs: {
                    portBody: {
                        magnet: 'passive',
                        width: 'calc(w)',
                        height: 'calc(h)',
                        fill: '#4665E5'
                    }
                },
                markup: [{
                    tagName: 'rect',
                    selector: 'portBody'
                }]
            }
        }
    }
});

export const Label = dia.Element.define('app.Label', {
    z: 3,
    attrs: {
        label: {
            fontFamily: 'sans-serif'
        }
    }
}, {
    markup: [{
        tagName: 'text',
        selector: 'label'
    }]
});

export const Edge = dia.Link.define('app.Edge', {
    z: 2,
    attrs: {
        line: {
            fill: 'none',
            connection: true,
            stroke: '#464454',
            strokeWidth: 1,
            targetMarker: { 'd': 'M 5 2.5 0 0 5 -2.5 Z' }
        }
    }
}, {
    markup: [{
        tagName: 'path',
        selector: 'line'
    }]
});
